<div class="card card-borderless"
     #cardRoot
     [style.min-height.px]="minHeight">
    <div class="card-header p-0"
         #processMapHeader>
        <h2 class="card-title d-flex align-items-center process-map-header">
            @if (processStepStackFrames.length > 0) {
                <adapt-display-process-step-hierarchy [processStep]="parentStep || processMap"
                                                      [processStepStackFrames]="processStepStackFrames"
                                                      (processStepClick)="stackFrameChanged($event)"></adapt-display-process-step-hierarchy>
            } @else {
                {{ initialProcessMap!.name }}
            }
        </h2>
        <div class="card-header-buttons">
            @if (processMap && hasChildSteps) {
                <button adaptButtonIcon="fal fa-fw fa-file-export"
                        [adaptBlockingClick]="export"
                        data-test="export-process-map-button">Export</button>
            }
            @if (isEditing && hasEditPermission) {
                <adapt-menu [items]="editMenu"></adapt-menu>
            }
        </div>
    </div>
    <div class="card-body p-0">
        @if (parentStep?.labelLocations?.length) {
            <div class="mb-2">
                <adapt-display-labels [labelLocations]="parentStep!.labelLocations"
                                      data-test="labels-display"></adapt-display-labels>
            </div>
        }
        @if (parentStep?.extensions?.isRoleTask) {
            <div>
                <adapt-role-task-content class="d-block p-3"
                                         [roleTask]="parentStep"
                                         [isEditing]="isEditing"></adapt-role-task-content>
            </div>
        } @else {
            @if (parentStep?.supplementaryData?.description) {
                <div class="mb-2">
                    <div [froalaView]="parentStep!.supplementaryData?.description"></div>
                </div>
            }
            @if (processMap && systemComponent?.supplementaryData?.description) {
                <div class="mb-2">
                    <div [froalaView]="systemComponent!.supplementaryData!.description"></div>
                </div>
            }
            <adapt-render-process-steps class="d-block pattern overflow-auto rounded border"
                                        [processMap]="processMap"
                                        [parentStep]="parentStep"
                                        [isEditing]="isEditing && renderIsInitialised"
                                        (initialised)="renderIsInitialised = true"
                                        (stepClick)="processStepClicked($event)"></adapt-render-process-steps>
        }
    </div>
</div>
